import { WorkingStatus } from "../enums/working-status";
import { UserData } from "../interfaces/data/user-data.interface";
import { Operation } from "../models/subscription";
import { MapperService } from "./mapper-services";
import { Injectable } from "@angular/core";
import { Data } from "../interfaces/data/data.interface";
import { FinancialData } from "../interfaces/data/financial-data.interface";
import { VehicleData } from "../interfaces/data/vehicle-data.interface";

@Injectable({
    providedIn: 'root',
})
export class OperationReverseMapperService extends MapperService<Operation, Data>  {

    protected map(entity: Operation): Data {

        const data : Data =  {
            userData : this.mapPersonReverse(entity),
            vehicleData : this.mapVehicleReverse(entity),
            financialData : this.mapFinancialDataReverse(entity),
            operationData : null
        };

        return data;
    }

    protected mapVehicleReverse (operation: Operation) : VehicleData {  // VehicleData???

        const vehicle: VehicleData = {
            type: operation.vehicle.type,
            brand: operation.vehicle.brand,
            model: operation.vehicle.model,
            version: operation.vehicle.version, //Not mandatory
            price: operation.vehicle.price,
            vin: operation.vehicle.vin,
            modelYear: operation.vehicle.modelYear,
            mileage: operation.vehicle.mileage,
            annualMileage: operation.vehicle.annualMileage,
            plateNumber: operation.vehicle.plateNumber,
            firstRegistrationDate: operation.vehicle.firstRegistrationDate
        };

       return vehicle;
    }

    protected mapFinancialDataReverse (operation: Operation) : FinancialData{

        const today = new Date();

        const financialData: FinancialData = {
            channel: operation.financialData.channel ? operation.financialData.channel : '',
            price: operation.financialData.totalFinancedGrossAmount,
            currencyCode: '',
            nominalRate: operation.financialData.nominalRate,
            aprcRate: operation.financialData.aprcRate,
            amountFinanced: operation.financialData.totalFinancedGrossAmount,
            totalInterestGrossAmount: operation.financialData.totalInterestGrossAmount,
            totalCreditCost: operation.financialData.totalCreditCost,
            totalCreditCostInsurance: null,
            totalAmountDue: operation.financialData.totalAmountDue,
            totalAmountDueInsurance: null,
            installmentTotalGrossAmount: operation.financialData.installmentTotalGrossAmount,
            installmentTotalGrossAmountInsurance: 0,
            installmentFirstGrossAmount: 0, //operation.financialData.installmentFirstGrossAmount ? operation.financialData.installmentFirstGrossAmount : 0,
            installmentLastGrossAmount: 0, //operation.financialData.installmentLastGrossAmount ? operation.financialData.installmentLastGrossAmount : 0,
            installmentMonthlyGrossAmount: 0, //operation.financialData.installmentMonthlyGrossAmount ? operation.financialData.installmentMonthlyGrossAmount : 0,
            financedAndInsuranceTotalGrossAmount: operation.financialData.financedAndInsuranceTotalGrossAmount ? operation.financialData.financedAndInsuranceTotalGrossAmount : 0,
            vat: operation.financialData.vat,
            paymentProtectionInsurance: false, //operation.financialData.paymentProtectionInsurance,
            financialProduct: {
                id: operation.financialData.financialProduct?.id ? operation.financialData.financialProduct.id : '',
                name: operation.financialData.financialProduct?.name ? operation.financialData.financialProduct.name : '',
            },
            formalizationFee: {
                type: operation.financialData.formalizationFee.type,
                amount: operation.financialData.formalizationFee.amount,
                percentage: operation.financialData.formalizationFee.percentage,
            },
            financialProducts: null, //-DELETE
            secureCode: operation.financialData.secureCode,
            residualValue: operation.financialData.residualValue,
            duration: operation.financialData.duration ? operation.financialData.duration.toString() : '0',
            downPaymentGrossAmount: operation.financialData.downPaymentGrossAmount,
            annualMileages: operation.vehicle.annualMileage,
            installmentAndInsuranceTotalGrossAmount: 0, //TODO Ver si tienen sentido
            installmentAndInsuranceFirstGrossAmount: 0,
            installmentAndInsuranceLastGrossAmount: 0,
            secureCost: null,
            promotion: null,
            material: null,
            arrangementFeeCode: null,
            deferralType: null
        };

        return financialData;
    }

    protected mapPersonReverse(data: Operation) {

        const today = new Date();

        const userData : UserData = {
            idNumber : data.subscriptionId,
            vendor : '', // 'JAGUAR'
            salesman : data.vendorId,
            store : data.storeId,
            partner : data.partnerId ? data.partnerId: '',
            agreement: '',
            order: data.orderId,
            privacySettings: {
                switchPrivacy1: false,
                switchPrivacy2: false,
                switchPrivacy3: false,
                switchPrivacy4: false
            },
            coHolder: {key : ''}, //???
            identification: {
                dni : data.holder.personalData.nif,
                expirationNif : data.holder.personalData.nifExpiryDate ? data.holder.personalData.nifExpiryDate : new Date(),
            },
            personalDataInfo: {
                gender: data.holder.personalData.title,
                textFirst: data.holder.personalData.firstSurename,
                textName: data.holder.personalData.firstName,
                textSecond: data.holder.personalData.secondSurename
            },
            personalDataBirth: {
                country: {
                    code: data.holder.personalData.nationalityCountry.nationality,
                    name: data.holder.personalData.nationalityCountry.countryCode,  ///???
                    regime: data.holder.personalData.nationalityCountry.nationality
                },
                birthDate: data.holder.personalData.birthDate ? new Date(data.holder.personalData.birthDate) : new Date(today.getFullYear() - 18, today.getMonth(), today.getDay())
            },

            contactDataInfo: {
                email: data.holder.contactData.personalEmail,
                telephone: data.holder.contactData.personalMobilePhone
            },

            contractType: {
                workContractType: data.holder.businessData.contractType,
                stableWorkingStartDate: data.holder.businessData.startDate ? data.holder.businessData.startDate : new Date(),
                temporaryWorkingStartDate: null,
                temporaryWorkingEndDate: null,
                monthlyNetIncome: null
            },

            workingSituation : {
                workStatus: WorkingStatus[data.holder.businessData.workingStatus as keyof typeof WorkingStatus],
                workingSituationTitle: '',
                workingSituationSubtitle: '',
                companyName: data.holder.businessData.companyName,
                sectorText: data.holder.businessData.income?.incomeSource,
                branchText: data.holder.businessData.professionalBranch,
                professionText: data.holder.businessData.profession,
                //no working
                situationText: '',
                monthlyNetIncomeLabel: '',
                revenue: data.holder.businessData.income?.amount,
                lastJobText: '',
                notWorkingSituation: null,
                profession: undefined,
                branch: undefined,
                sector: undefined,
                company: "",
                laborSeniority : null // TODO ??
            },

            houseType: {
                typeHousingContract: '',
                year: '',
                cost: 0
            },
            houseAddress: {
                streetType: {code : data.holder.addressData?.streetType, name : data.holder.addressData?.streetName},
                streetName: data.holder.addressData?.streetName,
                streetNumber: data.holder.addressData?.streetNumber,
                streetAdditionalInfo: '', //data.holder.addressData.addressComplement ??,
                city: data.holder.addressData?.city,
                postalCode: data.holder.addressData?.zipCode,
                province: { code: data.holder.addressData?.province, name: data.holder.addressData?.province }
            },

            additionalDataFirst: {
                maritalStatus: '',
                childrenNumber: ''
            },
            additionalDataSecond: {
                year: '',
            },
            additionalDataLoan: {
                loanSituation: false,  // Pendiente mapeo
                cost: null
            },
            coOperator: {
                coOperatorRadioButton: false
            },
            bankDetails: {
                iban: ''
            },
            authenticationData: {
                auth: false
            },
            recruitment: {
                recruit: false
            },
            documentation: {
                upload1: null,
                upload2: null
            }
        };

        return userData;
     }

}